(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rodexol-product-information"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('rodexol-product-panel')) return;

    class RodexolProductPanel extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.soldFrame);

        this.scrollFrame = null;
        this.soldFrame = null;

        clearInterval(this.timer);
        clearTimeout(this.restoreTimeout);
        clearTimeout(this.soldTimeout);

        this.observer?.disconnect();
        this.soldObserver?.disconnect();
        this.controller?.abort();

        this.controller = null;
      }

      initialize() {
        if (this.controller || !this.isConnected) return;

        this.controller = new AbortController();

        const on = (target, event, handler, options = {}) => {
          target?.addEventListener(event, handler, {
            ...options,
            signal: this.controller.signal
          });
        };

        const find = (selector) => this.querySelector(selector);
        const all = (selector) => Array.from(this.querySelectorAll(selector));

        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        const behavior = () => reducedMotion.matches ? 'auto' : 'smooth';
        const mobile = matchMedia('(max-width: 989px)');

        /* ====================================================
           GALLERY
           ==================================================== */

        const track = find('[data-rd-track]');

        if (track) {
          track.style.scrollSnapType = '';
          track.classList.remove('is-dragging');
        }

        const slides = all('[data-rd-slide]');
        const thumbs = all('[data-rd-thumb]');
        const thumbTrack = find('[data-rd-thumbs]');
        const thumbShell = find('[data-rd-thumbs-shell]');
        const thumbPrev = find('[data-rd-thumb-prev]');
        const thumbNext = find('[data-rd-thumb-next]');
        const mainPrev = find('[data-rd-main-prev]');
        const mainNext = find('[data-rd-main-next]');
        const status = find('[data-rd-gallery-status]');

        let activeIndex = 0;
        let lastWidth = 0;
        let drag = null;

        const clamp = (index) => {
          return Math.max(0, Math.min(index, slides.length - 1));
        };

        const updateThumbControls = () => {
          if (!thumbTrack) return;

          const max = Math.max(
            0,
            thumbTrack.scrollWidth - thumbTrack.clientWidth
          );

          thumbShell.classList.toggle('has-overflow', max > 2);

          if (thumbPrev) {
            thumbPrev.disabled = max < 2 || thumbTrack.scrollLeft < 2;
          }

          if (thumbNext) {
            thumbNext.disabled =
              max < 2 || thumbTrack.scrollLeft >= max - 2;
          }
        };

        const revealThumb = (index) => {
          const thumb = thumbs[index];

          if (!thumbTrack || !thumb) return;

          const left = thumb.offsetLeft;
          const right = left + thumb.offsetWidth;

          let destination = thumbTrack.scrollLeft;

          if (left < destination) {
            destination = left;
          } else if (right > destination + thumbTrack.clientWidth) {
            destination = right - thumbTrack.clientWidth;
          }

          if (Math.abs(destination - thumbTrack.scrollLeft) > 1) {
            thumbTrack.scrollTo({
              left: destination,
              behavior: behavior()
            });
          }
        };

        const setActive = (index, reveal = true) => {
          activeIndex = clamp(index);

          slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === activeIndex);
            slide.setAttribute('aria-hidden', String(i !== activeIndex));
          });

          thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === activeIndex);
            thumb.setAttribute('aria-current', String(i === activeIndex));
          });

          if (mainPrev) {
            mainPrev.disabled = activeIndex === 0;
          }

          if (mainNext) {
            mainNext.disabled = activeIndex === slides.length - 1;
          }

          if (status && slides.length > 1) {
            const value = `${activeIndex + 1} / ${slides.length}`;

            if (status.textContent !== value) {
              status.textContent = value;
            }
          }

          if (reveal) {
            revealThumb(activeIndex);
          }
        };

        const goTo = (index, motion = behavior()) => {
          if (!track) return;

          const next = clamp(index);

          track.scrollTo({
            left: next * track.clientWidth,
            behavior: motion
          });

          setActive(next);
        };

        on(track, 'scroll', () => {
          if (this.scrollFrame) return;

          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;

            if (track.clientWidth) {
              setActive(
                Math.round(track.scrollLeft / track.clientWidth)
              );
            }
          });
        }, { passive: true });

        thumbs.forEach((thumb, i) => {
          on(thumb, 'click', () => goTo(i));
        });

        on(mainPrev, 'click', () => goTo(activeIndex - 1));
        on(mainNext, 'click', () => goTo(activeIndex + 1));

        on(track, 'keydown', (event) => {
          if (
            event.altKey ||
            event.ctrlKey ||
            event.metaKey
          ) {
            return;
          }

          let index;

          if (event.key === 'ArrowRight') {
            index = activeIndex + 1;
          }

          if (event.key === 'ArrowLeft') {
            index = activeIndex - 1;
          }

          if (event.key === 'Home') {
            index = 0;
          }

          if (event.key === 'End') {
            index = slides.length - 1;
          }

          if (index === undefined) return;

          event.preventDefault();
          goTo(index);
        });

        const moveThumbs = (direction) => {
          if (!thumbTrack) return;

          const gap =
            parseFloat(getComputedStyle(thumbTrack).columnGap) || 0;

          const step = thumbs[0]
            ? (thumbs[0].offsetWidth + gap) * 2
            : thumbTrack.clientWidth;

          thumbTrack.scrollBy({
            left: direction * step,
            behavior: behavior()
          });
        };

        on(thumbPrev, 'click', () => moveThumbs(-1));
        on(thumbNext, 'click', () => moveThumbs(1));

        on(
          thumbTrack,
          'scroll',
          updateThumbControls,
          { passive: true }
        );

        /* Mouse dragging */

        on(track, 'pointerdown', (event) => {
          if (
            event.pointerType !== 'mouse' ||
            event.button !== 0 ||
            slides.length < 2
          ) {
            return;
          }

          event.preventDefault();

          track.focus({
            preventScroll: true
          });

          drag = {
            id: event.pointerId,
            x: event.clientX,
            left: track.scrollLeft
          };

          track.style.scrollSnapType = 'none';
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        });

        on(track, 'pointermove', (event) => {
          if (
            drag &&
            event.pointerId === drag.id
          ) {
            track.scrollLeft =
              drag.left -
              (event.clientX - drag.x);
          }
        });

        const endDrag = (event) => {
          if (
            !drag ||
            event.pointerId !== drag.id
          ) {
            return;
          }

          const id = drag.id;
          drag = null;

          track.classList.remove('is-dragging');
          track.style.scrollSnapType = '';

          if (track.hasPointerCapture(id)) {
            track.releasePointerCapture(id);
          }

          goTo(
            Math.round(
              track.scrollLeft /
              track.clientWidth
            )
          );
        };

        on(track, 'pointerup', endDrag);
        on(track, 'pointercancel', endDrag);
        on(track, 'lostpointercapture', endDrag);

        const resizeGallery = () => {
          if (
            track &&
            track.clientWidth &&
            track.clientWidth !== lastWidth
          ) {
            lastWidth = track.clientWidth;

            track.scrollTo({
              left: activeIndex * lastWidth,
              behavior: 'auto'
            });
          }

          updateThumbControls();
        };

        if ('ResizeObserver' in window) {
          this.observer =
            new ResizeObserver(resizeGallery);

          if (track) {
            this.observer.observe(track);
          }

          if (thumbTrack) {
            this.observer.observe(thumbTrack);
          }
        } else {
          on(window, 'resize', resizeGallery);
        }

        setActive(0, false);
        resizeGallery();

        /* ====================================================
           ACCORDIONS
           ==================================================== */

        const accordions =
          all('[data-rd-accordion]');

        const applyAccordionDefaults = () => {
          const close =
            mobile.matches &&
            this.dataset.compact === 'true' &&
            this.dataset.closeMobile === 'true';

          accordions.forEach((accordion) => {
            if (
              accordion.dataset.touched !== 'true'
            ) {
              accordion.open =
                !close &&
                accordion.dataset.defaultOpen === 'true';
            }
          });
        };

        accordions.forEach((accordion) => {
          const summary =
            accordion.querySelector('summary');

          on(summary, 'click', () => {
            accordion.dataset.touched = 'true';
          });

          on(accordion, 'toggle', () => {
            summary.setAttribute(
              'aria-expanded',
              String(accordion.open)
            );
          });
        });

        applyAccordionDefaults();

        on(
          mobile,
          'change',
          applyAccordionDefaults
        );

        /* ====================================================
           INGREDIENT DESCRIPTIONS
           ==================================================== */

        const ingredients =
          all('[data-rd-ingredient]').map(
            (button) => {
              const wrapper =
                button.closest('.rd-ingredient');

              return {
                button,
                wrapper,
                panel: wrapper.querySelector(
                  '.rd-ingredient__tooltip'
                )
              };
            }
          );

        const toggleIngredient = (
          entry,
          open
        ) => {
          entry.panel.hidden = !open;

          entry.button.setAttribute(
            'aria-expanded',
            String(open)
          );
        };

        ingredients.forEach((entry) => {
          on(entry.button, 'click', () => {
            const open = entry.panel.hidden;

            ingredients.forEach((item) => {
              toggleIngredient(
                item,
                item === entry && open
              );
            });
          });

          on(entry.wrapper, 'mouseenter', () => {
            if (
              matchMedia('(hover: hover)').matches
            ) {
              toggleIngredient(entry, true);
            }
          });

          on(entry.wrapper, 'mouseleave', () => {
            if (
              !entry.wrapper.contains(
                document.activeElement
              )
            ) {
              toggleIngredient(entry, false);
            }
          });

          on(
            entry.wrapper,
            'focusout',
            (event) => {
              if (
                !entry.wrapper.contains(
                  event.relatedTarget
                )
              ) {
                toggleIngredient(entry, false);
              }
            }
          );
        });

        on(document, 'pointerdown', (event) => {
          ingredients.forEach((entry) => {
            if (
              !entry.wrapper.contains(event.target)
            ) {
              toggleIngredient(entry, false);
            }
          });
        });

        on(this, 'keydown', (event) => {
          if (event.key === 'Escape') {
            ingredients.forEach((entry) => {
              toggleIngredient(entry, false);
            });
          }
        });

        /* ====================================================
           THEME EDITOR BLOCK SELECTION
           ==================================================== */

        on(
          this,
          'shopify:block:select',
          (event) => {
            const target =
              event.target instanceof Element
                ? event.target
                : null;

            const slide =
              target?.closest('[data-rd-slide]');

            const accordion =
              target?.closest(
                '[data-rd-accordion]'
              );

            if (slide) {
              goTo(
                Number(
                  slide.dataset.rdSlide
                ),
                'auto'
              );
            }

            if (accordion) {
              accordion.open = true;
            }
          }
        );

        /* ====================================================
           SESSION COUNTDOWN
           ==================================================== */

        const countdown =
          find('[data-rd-countdown]');

        if (countdown) {
          const duration =
            Math.max(
              1,
              Number(
                this.dataset.timerMinutes
              ) || 180
            ) * 60000;

          const key =
            `rodexol-timer-${this.dataset.sectionId}`;

          let target = 0;

          try {
            target =
              Number(
                sessionStorage.getItem(key)
              );
          } catch (_) {}

          const tick = () => {
            if (
              !Number.isFinite(target) ||
              target <= Date.now()
            ) {
              target =
                Date.now() + duration;

              try {
                sessionStorage.setItem(
                  key,
                  String(target)
                );
              } catch (_) {}
            }

            const remaining =
              Math.max(
                0,
                Math.floor(
                  (target - Date.now()) /
                  1000
                )
              );

            countdown.textContent = [
              Math.floor(
                remaining / 3600
              ),
              Math.floor(
                remaining % 3600 / 60
              ),
              remaining % 60
            ]
              .map(
                (value) =>
                  String(value).padStart(
                    2,
                    '0'
                  )
              )
              .join(':');
          };

          tick();

          this.timer =
            setInterval(tick, 1000);
        }

        /* ====================================================
           ANIMATED SOLD PROGRESS
           ==================================================== */

        const soldProgress =
          find('[data-rd-sold-progress]');

        const soldFill =
          find('[data-rd-sold-fill]');

        const soldNumber =
          find('[data-rd-sold-number]');

        const soldBar =
          find('[data-rd-sold-bar]');

        if (
          soldProgress &&
          soldFill &&
          soldNumber &&
          soldBar
        ) {
          const soldTarget =
            Math.max(
              0,
              Math.min(
                100,
                Number(
                  this.dataset.soldTarget
                ) || 93
              )
            );

          const soldDuration =
            Math.max(
              400,
              Number(
                this.dataset.soldDuration
              ) || 2800
            );

          const soldDelay =
            Math.max(
              0,
              Number(
                this.dataset.soldDelay
              ) || 0
            );

          const soldReplay =
            this.dataset.soldReplay === 'true';

          let soldPlayed = false;
          let soldRunning = false;

          const setSoldValue = (value) => {
            const safeValue =
              Math.max(
                0,
                Math.min(
                  soldTarget,
                  value
                )
              );

            const rounded =
              Math.round(safeValue);

            soldFill.style.width =
              `${safeValue}%`;

            soldNumber.textContent =
              String(rounded);

            soldBar.setAttribute(
              'aria-valuenow',
              String(rounded)
            );

            const soldLabel =
              this.dataset.soldLabel || '';

            soldBar.setAttribute(
              'aria-valuetext',
              `${rounded}% ${soldLabel}`.trim()
            );
          };

          const resetSold = () => {
            cancelAnimationFrame(
              this.soldFrame
            );

            clearTimeout(
              this.soldTimeout
            );

            this.soldFrame = null;
            this.soldTimeout = null;

            soldRunning = false;

            setSoldValue(0);
          };

          const runSold = () => {
            if (
              soldRunning ||
              (!soldReplay && soldPlayed)
            ) {
              return;
            }

            clearTimeout(
              this.soldTimeout
            );

            soldRunning = true;

            this.soldTimeout =
              setTimeout(() => {
                const startedAt =
                  performance.now();

                const tickSold = (now) => {
                  const elapsed =
                    now - startedAt;

                  const progress =
                    Math.min(
                      1,
                      elapsed /
                      soldDuration
                    );

                  const eased =
                    1 -
                    Math.pow(
                      1 - progress,
                      3
                    );

                  setSoldValue(
                    soldTarget *
                    eased
                  );

                  if (progress < 1) {
                    this.soldFrame =
                      requestAnimationFrame(
                        tickSold
                      );

                    return;
                  }

                  setSoldValue(
                    soldTarget
                  );

                  soldPlayed = true;
                  soldRunning = false;
                  this.soldFrame = null;

                  if (!soldReplay) {
                    this.soldObserver
                      ?.disconnect();
                  }
                };

                this.soldFrame =
                  requestAnimationFrame(
                    tickSold
                  );
              }, soldDelay);
          };

          resetSold();

          if (reducedMotion.matches) {
            setSoldValue(soldTarget);
            soldPlayed = true;
          } else if (
            'IntersectionObserver' in window
          ) {
            this.soldObserver =
              new IntersectionObserver(
                (entries) => {
                  entries.forEach(
                    (entry) => {
                      if (
                        entry.isIntersecting &&
                        entry.intersectionRatio >= 0.25
                      ) {
                        runSold();
                      } else if (
                        soldReplay &&
                        soldPlayed
                      ) {
                        soldPlayed = false;
                        resetSold();
                      }
                    }
                  );
                },
                {
                  threshold: [
                    0,
                    0.25,
                    0.5,
                    1
                  ],
                  rootMargin:
                    '0px 0px -4% 0px'
                }
              );

            this.soldObserver.observe(
              soldProgress
            );
          } else {
            runSold();
          }
        }

        /* ====================================================
           BUNDLE SELECTOR
           ==================================================== */

        const offers =
          all('[data-rd-offer]');

        const cta =
          find('[data-rd-add-bundle]');

        const label =
          find('[data-rd-cta-label]');

        const message =
          find('[data-rd-message]');

        const selectedOffer = () => {
          return offers.find(
            (offer) => offer.checked
          );
        };

        let busy = false;

        if (
          !selectedOffer() ||
          selectedOffer().disabled
        ) {
          const first =
            offers.find(
              (offer) =>
                !offer.disabled &&
                offer.dataset.variantId
            ) ||
            offers.find(
              (offer) =>
                !offer.disabled
            );

          if (first) {
            first.checked = true;
          }
        }

        const updateButton = () => {
          if (
            !cta ||
            !label ||
            busy
          ) {
            return;
          }

          const selected =
            selectedOffer();

          cta.disabled =
            !selected ||
            selected.disabled;

          const price =
            this.dataset.showPrice === 'true' &&
            selected?.dataset.price
              ? ` — ${selected.dataset.price}`
              : '';

          label.textContent =
            this.dataset.buttonText +
            price;
        };

        offers.forEach((offer) => {
          on(offer, 'change', () => {
            clearTimeout(
              this.restoreTimeout
            );

            message.hidden = true;

            updateButton();
          });
        });

        updateButton();

        /* ====================================================
           AJAX ADD TO CART
           ==================================================== */

        on(cta, 'click', async () => {
          if (busy) return;

          const selected =
            selectedOffer();

          const variantId =
            Number(
              selected?.dataset.variantId
            );

          if (
            !Number.isSafeInteger(
              variantId
            ) ||
            variantId <= 0 ||
            selected.disabled
          ) {
            message.textContent =
              'Please select an available bundle product in Theme Editor.';

            message.hidden = false;

            return;
          }

          clearTimeout(
            this.restoreTimeout
          );

          busy = true;

          cta.disabled = true;

          cta.setAttribute(
            'aria-busy',
            'true'
          );

          label.textContent =
            this.dataset.addingText;

          message.hidden = true;

          const cartUrl =
            this.dataset.cartUrl ||
            '/cart';

          try {
            const cart =
              document.querySelector(
                'cart-drawer'
              ) ||
              document.querySelector(
                'cart-notification'
              );

            const sections =
              cart &&
              typeof cart.getSectionsToRender ===
                'function'
                ? [
                    ...new Set(
                      cart
                        .getSectionsToRender()
                        .map(
                          (item) =>
                            item.id
                        )
                    )
                  ].slice(0, 5)
                : [];

            const payload = {
              items: [
                {
                  id: variantId,
                  quantity: 1
                }
              ]
            };

            if (sections.length) {
              payload.sections =
                sections;

              payload.sections_url =
                window.location.pathname;
            }

            const response =
              await fetch(
                this.dataset.cartAddUrl,
                {
                  method: 'POST',
                  credentials:
                    'same-origin',
                  headers: {
                    'Content-Type':
                      'application/json',
                    Accept:
                      'application/json'
                  },
                  body:
                    JSON.stringify(
                      payload
                    )
                }
              );

            const data =
              await response.json();

            if (
              !response.ok ||
              data.status
            ) {
              throw new Error(
                data.description ||
                data.message ||
                'Unable to add this offer.'
              );
            }

            if (!this.isConnected) {
              return;
            }

            const canRender =
              cart &&
              typeof cart.renderContents ===
                'function' &&
              sections.length &&
              sections.every(
                (id) =>
                  typeof data.sections?.[id] ===
                    'string' &&
                  data.sections[id].trim()
              );

            if (canRender) {
              try {
                const item =
                  data.items?.[0] ||
                  data;

                cart.setActiveElement?.(
                  cta
                );

                cart.classList.remove(
                  'is-empty'
                );

                cart.renderContents({
                  ...data,
                  id: item.id,
                  key: item.key
                });
              } catch (_) {
                window.location.assign(
                  cartUrl
                );

                return;
              }
            } else {
              window.location.assign(
                cartUrl
              );

              return;
            }

            label.textContent =
              this.dataset.addedText;

            this.restoreTimeout =
              setTimeout(
                updateButton,
                1000
              );

          } catch (error) {
            if (!this.isConnected) {
              return;
            }

            message.textContent =
              error.message ||
              'Unable to add this offer. Please try again.';

            message.hidden = false;

            label.textContent =
              this.dataset.buttonText;

          } finally {
            busy = false;

            cta.removeAttribute(
              'aria-busy'
            );

            cta.disabled =
              !selectedOffer() ||
              selectedOffer().disabled;

            if (!message.hidden) {
              updateButton();
            }
          }
        });
      }
    }

    customElements.define(
      'rodexol-product-panel',
      RodexolProductPanel
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rodexol-real-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rodexol-real-results')) {
    class RodexolRealResults extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.layoutFrame);

        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.videoObserver?.disconnect();

        this.states?.forEach((state) => {
          clearTimeout(state.timer);
          cancelAnimationFrame(state.frame);
        });

        this.videos?.forEach(({ video }) => video.pause());
      }

      initialize() {
        this.events?.abort();
        this.events = new AbortController();

        const options = { signal: this.events.signal };

        this.mobile = window.matchMedia('(max-width: 989px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));

        this.states = Array.from(
          this.querySelectorAll('[data-panel]')
        ).map((panel) => ({
          panel,
          category: panel.dataset.panel,
          track: panel.querySelector('[data-track]'),
          cards: Array.from(panel.querySelectorAll('[data-review]')),
          counter: panel.querySelector('[data-counter]'),
          index: 0,
          programmatic: false
        }));

        this.setAttribute('data-ready', '');

        /* Category tabs */

        this.tabs.forEach((tab, index) => {
          tab.addEventListener(
            'click',
            () => this.select(tab.dataset.tab),
            options
          );

          tab.addEventListener('keydown', (event) => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next;

            if (event.key === 'ArrowRight') {
              next = index + (rtl ? -1 : 1);
            } else if (event.key === 'ArrowLeft') {
              next = index + (rtl ? 1 : -1);
            } else if (event.key === 'Home') {
              next = 0;
            } else if (event.key === 'End') {
              next = this.tabs.length - 1;
            } else {
              return;
            }

            event.preventDefault();

            const target = this.tabs[
              (next + this.tabs.length) % this.tabs.length
            ];

            this.select(target.dataset.tab);
            target.focus({ preventScroll: true });
          }, options);
        });

        /* Review swipe / arrows */

        this.states.forEach((state) => {
          state.panel.querySelector('[data-prev]')
            ?.addEventListener('click', () => {
              this.go(state, state.index - 1);
            }, options);

          state.panel.querySelector('[data-next]')
            ?.addEventListener('click', () => {
              this.go(state, state.index + 1);
            }, options);

          state.track.addEventListener('pointerdown', () => {
            state.programmatic = false;
          }, options);

          state.track.addEventListener('scroll', () => {
            cancelAnimationFrame(state.frame);

            state.frame = requestAnimationFrame(() => {
              if (!state.programmatic) {
                this.synchronize(state);
              }
            });

            clearTimeout(state.timer);

            state.timer = setTimeout(() => {
              state.programmatic = false;
              this.synchronize(state);
            }, 140);
          }, { ...options, passive: true });

          state.track.addEventListener('keydown', (event) => {
            if (
              event.target !== state.track ||
              !this.mobile.matches
            ) {
              return;
            }

            const rtl = getComputedStyle(this).direction === 'rtl';
            let next;

            if (event.key === 'ArrowRight') {
              next = state.index + (rtl ? -1 : 1);
            } else if (event.key === 'ArrowLeft') {
              next = state.index + (rtl ? 1 : -1);
            } else if (event.key === 'Home') {
              next = 0;
            } else if (event.key === 'End') {
              next = state.cards.length - 1;
            } else {
              return;
            }

            event.preventDefault();
            this.go(state, next);
          }, options);

          state.track.addEventListener('focusin', (event) => {
            const card = event.target.closest('[data-review]');
            const index = state.cards.indexOf(card);

            if (index >= 0 && index !== state.index) {
              this.go(state, index, true);
            }
          }, options);
        });

        /* Selecting a Shopify block reveals its category and card. */

        this.addEventListener('shopify:block:select', (event) => {
          if (!(event.target instanceof Element)) {
            return;
          }

          const card = event.target.closest('[data-review]');

          const state = this.states.find(
            (item) => item.cards.includes(card)
          );

          if (state) {
            this.select(
              state.category,
              state.cards.indexOf(card)
            );

            card.scrollIntoView({
              block: 'nearest',
              inline: 'nearest',
              behavior: 'instant'
            });
          } else {
            event.target.closest('.rdr2-media-card')
              ?.scrollIntoView({
                block: 'nearest',
                inline: 'nearest',
                behavior: 'instant'
              });
          }
        }, options);

        /* Recalculate slide position and height after resizing. */

        const layout = () => {
          cancelAnimationFrame(this.layoutFrame);

          this.layoutFrame = requestAnimationFrame(() => {
            if (this.active) {
              this.go(this.active, this.active.index, true);
            }

            this.states.forEach((state) => this.fit(state));
          });
        };

        this.mobile.addEventListener('change', layout, options);
        window.addEventListener('resize', layout, options);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            if (this.active) {
              this.fit(this.active);
            }
          });

          this.states.forEach((state) => {
            state.cards.forEach((card) => {
              this.resizeObserver.observe(card);
            });
          });
        }

        const selected = this.tabs.find(
          (tab) => tab.getAttribute('aria-selected') === 'true'
        );

        this.select(selected?.dataset.tab || 'tab_1');
        this.initializeVideos(options);
      }

      select(category, index = 0) {
        const state = this.states.find(
          (item) => item.category === category
        );

        if (!state) {
          return;
        }

        this.active = state;

        this.states.forEach((item) => {
          item.panel.hidden = item !== state;
        });

        this.tabs.forEach((tab) => {
          const active = tab.dataset.tab === category;

          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        this.go(state, index, true);
      }

      distance(track, card) {
        const outer = track.getBoundingClientRect();
        const inner = card.getBoundingClientRect();

        return getComputedStyle(this).direction === 'rtl'
          ? inner.right - outer.right
          : inner.left - outer.left;
      }

      go(state, index, instant = false) {
        if (!state.cards.length) {
          return;
        }

        state.index =
          (index + state.cards.length) % state.cards.length;

        if (this.mobile.matches && !state.panel.hidden) {
          state.programmatic = !instant;

          state.track.scrollTo({
            left:
              state.track.scrollLeft +
              this.distance(
                state.track,
                state.cards[state.index]
              ),
            behavior:
              instant || this.reduced.matches
                ? 'instant'
                : 'smooth'
          });
        }

        this.fit(state);
        this.updateCounter(state);
      }

      synchronize(state) {
        if (!this.mobile.matches || state.panel.hidden) {
          return;
        }

        let nearest = 0;
        let distance = Infinity;

        state.cards.forEach((card, index) => {
          const current = Math.abs(
            this.distance(state.track, card)
          );

          if (current < distance) {
            distance = current;
            nearest = index;
          }
        });

        state.index = nearest;

        this.fit(state);
        this.updateCounter(state);
      }

      fit(state) {
        if (!this.mobile.matches) {
          state.track.style.removeProperty('height');
          return;
        }

        if (state.panel.hidden) {
          return;
        }

        const card = state.cards[state.index];

        if (!card) {
          return;
        }

        const height =
          `${Math.ceil(card.getBoundingClientRect().height)}px`;

        if (state.track.style.height !== height) {
          state.track.style.height = height;
        }
      }

      updateCounter(state) {
        if (!state.counter) {
          return;
        }

        const text =
          `${state.index + 1} / ${state.cards.length}`;

        if (state.counter.textContent !== text) {
          state.counter.textContent = text;
        }
      }

      initializeVideos(options) {
        this.manualVideo = false;

        this.videos = Array.from(
          this.querySelectorAll('video')
        ).map((video) => {
          const card = video.closest('.rdr2-media-card');

          const record = {
            video,
            button: card.querySelector('[data-play]'),
            error: card.querySelector('[data-video-error]'),
            ratio: 0,
            attempted: false
          };

          /*
            Without JS, native controls remain available.
            With JS, the initial play button opens native controls.
          */
          video.controls = !video.paused;
          record.button.hidden = !video.paused;

          record.button.addEventListener('click', () => {
            this.manualVideo = true;
            video.muted = false;
            this.playVideo(record, false);
          }, options);

          video.addEventListener('pointerdown', () => {
            this.manualVideo = true;
          }, options);

          video.addEventListener('play', () => {
            this.videos.forEach((other) => {
              if (other.video !== video) {
                other.video.pause();
              }
            });

            record.button.hidden = true;
            video.controls = true;
            record.error.hidden = true;
          }, options);

          video.addEventListener('error', () => {
            record.button.hidden = true;
            video.controls = true;
            record.error.hidden = false;
          }, options);

          return record;
        });

        const pause = () => {
          this.videos.forEach(({ video }) => video.pause());
        };

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            pause();
          }
        }, options);

        window.addEventListener('pagehide', pause, options);
        this.mobile.addEventListener('change', pause, options);

        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const record = this.videos.find(
                  ({ video }) => video === entry.target
                );

                if (!record) {
                  return;
                }

                record.ratio = entry.intersectionRatio;

                if (record.ratio < 0.1) {
                  record.video.pause();
                }
              });

              this.tryAutoplay();
            },
            { threshold: [0, 0.1, 0.6] }
          );

          this.videos.forEach(({ video }) => {
            this.videoObserver.observe(video);
          });
        }
      }

      tryAutoplay() {
        const enabled = this.mobile.matches
          ? this.dataset.autoplayMobile === 'true'
          : this.dataset.autoplayDesktop === 'true';

        if (
          !enabled ||
          this.dataset.editor === 'true' ||
          this.manualVideo ||
          this.reduced.matches ||
          document.hidden ||
          navigator.connection?.saveData ||
          this.videos.some(({ video }) => !video.paused)
        ) {
          return;
        }

        const record = this.videos.find(
          (item) => !item.attempted && item.ratio >= 0.6
        );

        if (!record) {
          return;
        }

        record.attempted = true;
        record.video.muted = true;

        this.playVideo(record, true);
      }

      async playVideo(record, automatic) {
        const signal = this.events.signal;

        record.error.hidden = true;

        try {
          await record.video.play();

          if (
            signal.aborted ||
            !this.isConnected ||
            document.hidden
          ) {
            record.video.pause();
          } else if (!automatic) {
            record.video.focus({ preventScroll: true });
          }
        } catch (error) {
          if (
            !automatic &&
            !signal.aborted &&
            error.name !== 'AbortError'
          ) {
            record.video.controls = true;
            record.button.hidden = true;
            record.error.hidden = false;
          }
        }
      }
    }

    customElements.define(
      'rodexol-real-results',
      RodexolRealResults
    );
  }

  } catch(e) { console.error(e); }
})();
})();
